import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route, Switch } from "react-router-dom";
import RequestApp from "./requests-list";
import BookingApp from "./bookings-list";
import FastCheckinApp from "./fastCheckin-list";
import Restaurants from "../../../components/alacarte/Restaurants";
import AlacarteRequests from "../../../components/alacarte/AlacarteRequests";
import BookingDetailsContainer from "../../../containers/bookings/BookingDetailsContainer";
import RequestDetailsContainer from "../../../containers/requests/RequestDetailsContainer";
import AlacarteRequestDetailsContainer from "../../../containers/requests/AlacarteRequestDetailsContainer";
import FastCheckinDetailsContainer from "../../../containers/fastCheckin/FastCheckinDetailsContainer";
import LolRequestsList from "./lolRequests-list";
import EaseeView from "../../../components/easee/EaseeView";
import WebeeAdminIframe from "../../../components/easee/WebeeAdminIframe";
import StaffTemplateMessage from "../../../components/settings/template/StaffTemplateMessage";
import RingTone from "../../../components/settings/ringTone/index";
import ReportProblem from "../../../components/settings/reportProblem";
import PopupAnnouncement from "../../../components/announcement/PopupAnnouncement";

const Staff = ({ match }) => (
  <div className="dashboard-wrapper">
    <PopupAnnouncement />
    <Switch>
      <Route path={`${match.url}/requests/:id`} component={RequestDetailsContainer} />
      <Route path={`${match.url}/requests`} component={RequestApp} />
      <Route path={`${match.url}/bookings/:id`} component={BookingDetailsContainer} />
      <Route path={`${match.url}/bookings`} component={BookingApp} />
      <Route path={`${match.url}/fastCheckin/:id`} component={FastCheckinDetailsContainer} />
      <Route path={`${match.url}/fastCheckin`} component={FastCheckinApp} />
      <Route path={`${match.url}/lolRequests/:id`} component={RequestDetailsContainer} />
      <Route path={`${match.url}/lolRequests`} exact component={LolRequestsList} />
      <Route path={`${match.url}/alacarte/restaurants`} component={Restaurants} />
      <Route path={`${match.url}/alacarte/requests/:id`} component={AlacarteRequestDetailsContainer} />
      <Route path={`${match.url}/alacarte/requests`} component={AlacarteRequests} />
      <Route path={`${match.url}/webeeadmin`} component={WebeeAdminIframe} />
      <Route path={`${match.url}/easee`} component={EaseeView} />
      <Route path={`${match.url}/settings/template`} component={StaffTemplateMessage} />
      <Route path={`${match.url}/settings/ringTone`} component={RingTone} />
      <Route path={`${match.url}/settings/reportProblem`} component={ReportProblem} />
      <Redirect from={`${match.url}/`} to={`${match.url}/requests`} />
      {/* <Redirect to="/error" /> */}
    </Switch>
  </div>
);

Staff.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object.isRequired
};

export default Staff;
